import simpleModal from "../libs/simpleModal";

const moment = require('moment');
const profileTicketsModal = new simpleModal({id: 'OrderTicketsModal', small: true, bodyClass: 'profile-barcode-html'});

const openCloseMenu = function (menu) {
    menu.toggleClass('show');
    const opened = menu.is('.show')
    $(this).attr('aria-label', opened ? translate.menuButton.closeMenu : translate.menuButton.openMenu)
    $(this).attr('aria-expanded', opened ? 'true' : 'false')
    return opened
}
$(document)
    .on('click', '.show-hide-menu a', function (e) {
        e.preventDefault();
        if (openCloseMenu($(this).closest('.section-page-main'))) {
            $(this).closest('.section-page-main').find('ul[role="menu"] a[role="menuitem"]:visible:first').focus()
        }
    })
    .on('keydown', '.show-hide-menu a', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ' || e.key === 'Enter') {
            $(this).trigger('click')
            return false
        } else if (e.key === 'ArrowUp') {
            if (openCloseMenu($(this).closest('.section-page-main'))) {
                $(this).closest('.section-page-main').find('ul[role="menu"] a[role="menuitem"]:visible:last').focus()
                return false
            }
        }
    })
    .on('keydown', 'a.list-group-item', function (e) {
        switch (e.key) {
            case 'ArrowUp':
                if (this.parentElement.previousElementSibling) {
                    this.parentElement.previousElementSibling.querySelector('.list-group-item').focus()
                    return false
                }
                return true
            case 'ArrowDown':
                if (this.parentElement.nextElementSibling) {
                    this.parentElement.nextElementSibling.querySelector('.list-group-item').focus()
                    return false
                }
                return true
            case 'Enter':
                return true;
            case ' ':
                window.location.href=$(this).attr('href')
                return false;
            case 'Home':
                $(this).parent().siblings().first().find('.list-group-item').focus()
                return false;
            case 'End':
                $(this).parent().siblings().last().find('.list-group-item').focus()
                return false;
        }
    })

$(document).on('click', '.ajax-update-option .edit', function (e) {
    e.preventDefault();
    const place = $(this).closest('.ajax-update-option');
    place.addClass('editable').find('input,select,textarea').removeAttr('disabled').filter(':visible:first').focus();
})

$(document).on('click', '.ajax-update-option .cancel', function (e) {
    e.preventDefault()
    const place = $(this).closest('.ajax-update-option')
    place.removeClass('editable').find('input,select,textarea').attr('disabled', true)
});

$(document).on('submit', '.edit-profile-form', function (e) {
    e.preventDefault();
    spinner.show();
    const form = $(this)
    const data = new FormData(this);
    if (e.originalEvent.submitter) {
        data.append('field', e.originalEvent.submitter.value)
    }
    const response = $.ajax({
        url: form.attr('action'),
        type: form.attr('method'),
        data: data,
        processData: false,
        contentType: false,
    }).statusCode({
        200: function (response) {
            window.openAlert(response.message || '', 'success')
            for (const [name, value] of Object.entries(response.attributes)) {
                const valueArea = form.find(`.btn-save[value="${name}"]`).closest('.wrapper').find('.value')
                    .html(value)
                    .prevObject.siblings('.cancel').click()
            }
            form.find('.has-error').removeClass('has-error').find('.help-block-error').html('')
        },
        400: function (xhr) {
            for (const [name, messages] of Object.entries(xhr.responseJSON.errors)) {
                form.find(`[name*="[${name}]"]`).closest('.form-group,[data-name]').addClass('has-error')
                    .find('.help-block-error').html(messages.join('<br/>'))
            }
            window.openAlert(xhr.responseJSON.message || '', 'error')
        }
    }).always(() => {
        spinner.remove();
    });
});

$(document).on('click', '.show-tickets-modal', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const barcode = $.get($(this).attr('href'))
        .then((response) => {
            if (!response.length) {
                response = `Sorry, nothing found.`
            }
            profileTicketsModal.loadContent({
                header: window.translate.my_tickets_title,
                body: `<div class="modal-html">${response.toString()}</div>`
            });
        })
        .catch(() => {
            profileTicketsModal.loadContent({
                header: window.translate.my_tickets_title,
                body: `<div class="modal-html">Sorry, nothing found.</div>`
            });

        })
});
